import { Col, Flex } from "antd";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";

type IProps = {
  onNextStep: () => void;
};

export const EmptyDocumentsModal = observer(({ onNextStep }: IProps) => {
  const { actionModals } = useStores();

  const handleCloseModal = () => {
    actionModals.closeAll();
  };

  return (
    <Flex gap="large" className="margin-top-lg" justify="center">
      <Col>
        <CustomButton onClick={onNextStep}>Продолжить</CustomButton>
      </Col>
      <Col>
        <CustomButton type="default" onClick={handleCloseModal}>
          Отмена
        </CustomButton>
      </Col>
    </Flex>
  );
});
